export default {
    maxWidth: '1200px',
    gutter: '20px',
    containerPadding: '32px',
    maxWidthAndGutter: '1240px',
    breakpoints: {
        xs: '320px',
        sm: '480px',
        md: '768px',
        lg: '1024px',
        xlg: '1200px',
    },
};
//# sourceMappingURL=grid.js.map